import React from 'react';
import { StarIcon } from 'lucide-react';
import { TroveGenrePage } from '../../components/Trove/TroveGenrePage';
import type { TroveArticle, TroveEvent, TroveNominee } from '../../components/Trove/TroveGenrePage';
import type { ActivityPost } from '../../components/Trove/ActivityPostCard';
const activityPosts: ActivityPost[] = [{
  id: 1,
  type: 'New Release',
  title: 'The Way of Kings — Illustrated Edition',
  description: "Brandon Sanderson's epic fantasy now available in a stunning illustrated hardcover.",
  author: 'Brandon Sanderson',
  date: 'Oct 15, 2023',
  genre: 'Fantasy'
}, {
  id: 2,
  type: 'Audiobook Launch',
  title: 'Project Hail Mary — Full Cast Audio',
  description: "Andy Weir's beloved sci-fi adventure now available as a full cast audiobook production.",
  author: 'Andy Weir',
  date: 'Oct 14, 2023',
  genre: 'Science Fiction'
}, {
  id: 3,
  type: 'Collaboration Request',
  title: 'Seeking Co-Author for Epic Fantasy Series',
  description: 'Established fantasy author looking for co-writer for a new 5-book series. Experience required.',
  author: 'D. Morgan',
  date: 'Oct 13, 2023',
  genre: 'Fantasy'
}, {
  id: 4,
  type: 'Vendor Availability',
  title: 'Fantasy Map Illustrator — Taking Commissions',
  description: 'Specialising in hand-drawn fantasy world maps. Perfect for self-published authors.',
  author: 'Cartography Studio',
  date: 'Oct 12, 2023',
  genre: 'Fantasy'
}, {
  id: 5,
  type: 'Award Nomination',
  title: 'Best Indie Sci-Fi 2023 — Vote Now',
  description: 'Cast your vote for the best independently published science fiction of the year.',
  author: 'Indie Lit Awards',
  date: 'Oct 11, 2023',
  genre: 'Science Fiction'
}];
const articles: TroveArticle[] = [{
  id: 1,
  title: 'World-Building Techniques from Top Fantasy Authors',
  excerpt: 'Learn how bestselling authors craft immersive fantasy worlds...',
  author: 'Daniel Morgan',
  date: 'October 7, 2023',
  category: 'Fantasy',
  readTime: '11 min read',
  image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 2,
  title: 'Science Fiction Trends: AI and Beyond',
  excerpt: 'How contemporary sci-fi is tackling artificial intelligence...',
  author: 'Olivia Wu',
  date: 'October 5, 2023',
  category: 'Science Fiction',
  readTime: '8 min read',
  image: 'https://images.unsplash.com/photo-1501786223405-6d024d7c3b8d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
const interviews: TroveArticle[] = [{
  id: 103,
  title: 'N.K. Jemisin on World Building and Breaking Genre Boundaries',
  excerpt: 'The multiple Hugo Award winner discusses her approach to creating immersive fantasy worlds...',
  author: 'Speculative Fiction Today',
  date: 'October 11, 2023',
  category: 'Fantasy',
  readTime: '14 min read',
  image: 'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}, {
  id: 104,
  title: 'Andy Weir on Scientific Accuracy and Storytelling in Science Fiction',
  excerpt: 'The author of "The Martian" and "Project Hail Mary" shares his research process...',
  author: 'Science & Fiction',
  date: 'October 7, 2023',
  category: 'Science Fiction',
  readTime: '16 min read',
  image: 'https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}];
const podcasts: TroveArticle[] = [{
  id: 203,
  title: 'Imaginary Worlds',
  excerpt: 'Exploring how we create and live in worlds of fantasy and science fiction...',
  author: 'Eric Molinsky',
  date: 'Bi-weekly',
  category: 'Fantasy & Science Fiction',
  readTime: '30-40 min episodes',
  image: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}, {
  id: 204,
  title: 'Sword & Laser',
  excerpt: 'A science fiction and fantasy-themed book club, video show and podcast...',
  author: 'Veronica Belmont & Tom Merritt',
  date: 'Weekly',
  category: 'Fantasy & Science Fiction',
  readTime: '45-60 min episodes',
  image: 'https://images.unsplash.com/photo-1569982175971-d92b01cf8694?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}];
const upcomingEvents: TroveEvent[] = [{
  name: 'World Fantasy Convention',
  date: 'Nov 1, 2023',
  location: 'Columbus, OH'
}, {
  name: 'Sci-Fi & Fantasy Writers Summit',
  date: 'Nov 20, 2023',
  location: 'Virtual'
}];
const awardNominees: TroveNominee[] = [{
  id: 1,
  name: 'The Way of Kings',
  author: 'Brandon Sanderson',
  votes: 3241
}, {
  id: 2,
  name: 'Project Hail Mary',
  author: 'Andy Weir',
  votes: 2987
}];
const FantasySciFiTrove = () => <TroveGenrePage title="Fantasy & Science Fiction" subtitle="Explore the latest in speculative fiction, from epic fantasies to cutting-edge sci-fi" icon={<StarIcon className="h-6 w-6" data-id="element-17198" data-mp="1rukqlc6m7o67" />} searchPlaceholder="Search fantasy & sci-fi content..." activityPosts={activityPosts} articles={articles} interviews={interviews} podcasts={podcasts} upcomingEvents={upcomingEvents} awardNominees={awardNominees} articlesHref="/trove/fantasy-scifi/articles" data-id="element-17197" data-mp="1d0g5rmi91s8b" />;
export default FantasySciFiTrove;